import React, { memo, useRef, useState, useCallback } from 'react';
import { constants } from '../../../misc/helpers';

const Dragger = memo(({ endDrag, correctIndex1, correctIndex2, wrongIndex, closeIndex, locations, isSceneA, isSceneB, isSceneC, isSceneD, getPlacementType }: any) => {
	const [position, setPosition] = useState({x: 0, y: 0});
	const [target, setTarget] = useState<any>(null);
	const ref = useRef(null);


	const getAriaLabel = (type: any, index: number) => {
		var placementType = getPlacementType(type);
		var result = '';
		if(placementType !== 'test-scenario' && placementType !== 'tutorial' && placementType !== 'close') {
			result = placementType + ' ';
		}
		return result + 'placement ' + (index + 1);
	}

	const getTabIndx = (type: any, index: number) => {
		var placementType = getPlacementType(type);
		if(placementType === 'tutorial') {
			return -1;
		}
		return 0;
	}

	const checkIsRightPlacement = function(correctLocation1: any[], correctLocation2: any [], wrongLocation: any [], closeLocation: any [], selectedPercentage: number){
		const rangePercent = 5;

		let isCorrect1 = false;
		correctLocation1.forEach((el:any) => {
			let correctPercentage1 = el.position;
			isCorrect1 = selectedPercentage >= (correctPercentage1 - rangePercent) && selectedPercentage <= (correctPercentage1 + rangePercent); 
			if(isCorrect1) return;
		});
		let isCorrect2 = false;
		correctLocation2.forEach((el:any) => {
			let correctPercentage2 = el.position;
			isCorrect2 = selectedPercentage >= (correctPercentage2 - rangePercent) && selectedPercentage <= (correctPercentage2 + rangePercent); 
			if(isCorrect2) return;
		});
		let isWrong = false;
		wrongLocation.forEach((el:any) => {
			let wrongPercentage = el.position;
			isWrong = selectedPercentage >= (wrongPercentage - rangePercent) && selectedPercentage <= (wrongPercentage + rangePercent); 
			if(isWrong) return;
		});
		let isClose = false;
		closeLocation.forEach((el:any) => {
			let closePercentage = el.position;
			isClose = selectedPercentage >= (closePercentage - rangePercent) && selectedPercentage <= (closePercentage + rangePercent); 
			if(isClose) return;
		});

		return {
			isCorrect1,
			isCorrect2,
			isWrong,
			isClose
		};
		//return (isCorrect1 && isCorrect2 && isWrong && isClose);
	}
	const onStartCallback = useCallback(
		(e: any) => {
			const tmpTarget = e.target;
			setTarget(tmpTarget);
			const evt = e.type === 'touchstart' ? e.changedTouches[0] : e;
			const scaleCoef = Math.min($(window).width() / 1280, $(window).height() / 720);
			
			setPosition({
				x: Math.abs(tmpTarget.offsetLeft - evt.clientX / scaleCoef),
				y: Math.abs(tmpTarget.offsetTop - evt.clientY / scaleCoef)
			});
	
			tmpTarget.style.pointerEvents = 'none';
		},
		[],
	);

	const onMoveCallback = useCallback(
		(e: any) => {
			if (target && target.style.pointerEvents === 'none') {
				const evt = e.type === 'touchmove' ? e.changedTouches[0] : e;
				
				const scaleCoef = Math.min($(window).width() / 1280, $(window).height() / 720);
				const left = (evt.clientX / scaleCoef - position.x);
				const top = (evt.clientY / scaleCoef - position.y);
				
				target.style.left = `${left}px`;
				target.style.top = `${top}px`;
			}
		},
		[target, position],
	);

	const onEndCallbackBase = useCallback((percentage: number) => {
		let correctPlacement1 = locations.filter((f: any) => { return f.type == constants.placementType.correct1; });
		let correctPlacement2 = locations.filter((f: any) => { return f.type == constants.placementType.correct2; });
		let wrongPlacements = locations.filter((f: any) => { return f.type == constants.placementType.wrong; });
		let closePlacements = locations.filter((f: any) => { return f.type == constants.placementType.close; });

		let placementIndex = 0;
		let ifCorrectPlacement = checkIsRightPlacement(correctPlacement1, correctPlacement2, wrongPlacements, closePlacements, percentage)
		if (ifCorrectPlacement.isCorrect1) {
			placementIndex = correctIndex1;
		}
		else if (ifCorrectPlacement.isCorrect2) {
			placementIndex = correctIndex2;
		}
		else if (ifCorrectPlacement.isWrong) {
			placementIndex = wrongIndex;
		}
		else if (ifCorrectPlacement.isClose) {
			placementIndex = closeIndex;
		}

		endDrag(placementIndex);

		if(target && target.style)
			target.style.pointerEvents = 'initial';

	}, [target]);

	const onEndCallback = useCallback(
		(e: any) => {
			if (target) {
				let leftOfset = parseInt(target.style.left);
				let percentage = leftOfset / ref.current.clientWidth * 100;
				
				onEndCallbackBase(percentage);
			}
		},
		[target],
	);

	const placemenets = locations ? locations.map((elem: any, i: number) => {
		let className = 
			isSceneA
				? 'placementA'
				: isSceneB
					? 'placementB'
					: isSceneC
						? 'placementC'
						: isSceneD
							? 'placementD'
							: 'placement';
							
		return (<div 
			style={{pointerEvents: 'none', left: (elem.position + '%')}} 
			className={`${className} ${getPlacementType(elem.type)}`} key={i}
			tabIndex={getTabIndx(elem.type, i)}
			aria-label={getAriaLabel(elem.type, i)}
			role="button"
			onClick={() => {
				let dragger = document.getElementsByClassName('dragger-element')[0] as HTMLBaseElement;
				dragger.style.left = `${elem.position}%`;
				setTimeout(() =>{
					onEndCallbackBase(elem.position);
				}, 1000);
			}}
			onKeyPress={(e: any) => {
				console.log(e);
				if(e.which == 32){
					let dragger = document.getElementsByClassName('dragger-element')[0] as HTMLBaseElement;
					dragger.style.left = `${elem.position}%`;
					setTimeout(() =>{
						onEndCallbackBase(elem.position);
					}, 1000);
				}
			}}
		/>);
	}) : '';

	let draggerClassName = 
		isSceneA
			? 'dragger-areaA'
			: isSceneB
				? 'dragger-areaB'
				: isSceneC
					? 'dragger-areaC'
					: isSceneD
						? 'dragger-areaD'
						: 'dragger-area';
					
	return (
		<div
			className={`${draggerClassName} modal-disable-select`}
			onMouseMove={onMoveCallback}
			onMouseUp={onEndCallback}
			onTouchMove={onMoveCallback}
			onTouchEnd={onEndCallback}
			// role="presentation"
			ref={ref}>
			<div className="dragger-element"
				style={{
					background: 'url(assets/img/tourniquet-drag-this.png)',
					backgroundSize: '100%'
				}}
				onMouseDown={onStartCallback}
				onTouchStart={onStartCallback}
				// tabIndex={0}
				>
			</div>{/* this is placeholder for Tourniquete. Should be replaced with appropriate image. */}
			{placemenets}
		</div>
	);
});

export default Dragger;